module.exports = __webpack_public_path__ + "static/media/workspace-content.50bd44d2.svg";